// extracted by mini-css-extract-plugin
export default {"wrap":"zH-z","fullWidth":"AH-z","hideOnDesktop":"BH-z","content":"CH-z","hasOpenedNav":"DH-z","crumbsList":"EH-z","dropdownsWrap":"FH-z"};